
// ======== Listing Page Revies Count Down Start 
document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll(".count");
    const ratingCounter = document.querySelector(".rating_count");
    let counted = false;

    const duration = 2000; // 2 seconds

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting && !counted){
                counted = true;

                // Count for top ratings
                counters.forEach(counter => {
                    const target = parseFloat(counter.getAttribute("data-target"));
                    const startTime = performance.now();

                    const updateCount = (currentTime) => {
                        const elapsed = currentTime - startTime;
                        let progress = Math.min(elapsed / duration, 1);
                        counter.innerText = (target * progress).toFixed(1);
                        if(progress < 1){
                            requestAnimationFrame(updateCount);
                        } else {
                            counter.innerText = target.toFixed(1);
                        }
                    }
                    requestAnimationFrame(updateCount);
                });

                // Count for main rating
                if(ratingCounter){
                    const target = parseFloat(ratingCounter.getAttribute("data-target"));
                    const startTime = performance.now();

                    const updateRating = (currentTime) => {
                        const elapsed = currentTime - startTime;
                        let progress = Math.min(elapsed / duration, 1);
                        ratingCounter.innerText = (target * progress).toFixed(2);
                        if(progress < 1){
                            requestAnimationFrame(updateRating);
                        } else {
                            ratingCounter.innerText = target.toFixed(2);
                        }
                    }
                    requestAnimationFrame(updateRating);
                }

            }
        });
    }, { threshold: 0.5 });

    const reviewsTitleSection = document.querySelector(".reviews_title_section");
    if (reviewsTitleSection) {
      observer.observe(reviewsTitleSection);
    }
});
// ======== Listing Page Revies Count Down End
// ======== Listing Page Hero Count Down Start 
document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll(".count");
    let counted = false; // একবারেই count হবে

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !counted) {
                counted = true;
                counters.forEach(counter => {
                    const format = counter.getAttribute("data-format");
                    const target = parseFloat(counter.getAttribute("data-target"));
                    
                    const updateCount = () => {
                        let currentText = counter.innerText;
                        let count = parseFloat(currentText.replace('%','').replace(/[^0-9.]/g, '')) || 0;
                        
                        if (format === "number") {
                            // Number format (e.g., 4.8, 700)
                            const increment = target / 50; // Smooth animation
                            
                            if (count < target) {
                                count = Math.min(count + increment, target);
                                // Format: show decimals for ratings < 10, whole numbers for larger values
                                if (target < 10) {
                                    counter.innerText = count.toFixed(1);
                                } else {
                                    counter.innerText = Math.floor(count);
                                }
                                setTimeout(updateCount, 20);
                            } else {
                                if (target < 10) {
                                    counter.innerText = target.toFixed(1);
                                } else {
                                    counter.innerText = Math.floor(target);
                                }
                            }
                        } else {
                            // Percentage format (legacy)
                            const increment = target / 100;
                            
                            if (count < target) {
                                counter.innerText = Math.ceil(count + increment) + "%";
                                setTimeout(updateCount, 20);
                            } else {
                                counter.innerText = target + "%";
                            }
                        }
                    }
                    updateCount();
                });
            }
        });
    }, { threshold: 0.5 });

    const heroLastGap = document.querySelector(".hero_last_gap");
    if (heroLastGap) {
      observer.observe(heroLastGap);
    }
});
// ======== Listing Page Hero Count Down End 

// Hero Popup Start
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("hero_popup_id");
  if (!btn) return;
  
  const popupWrap = document.querySelector(".hero_popup_wrap");
  const iconMenu = btn.querySelector(".icon-menu");
  const iconClose = btn.querySelector(".icon-close");

  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    const isActive = popupWrap.classList.toggle("active");

    // JS handles icon switch
    if (isActive) {
      iconMenu.style.display = "none";
      iconClose.style.display = "block";
    } else {
      iconMenu.style.display = "block";
      iconClose.style.display = "none";
    }

    btn.setAttribute("aria-expanded", isActive);
  });

  // Click outside → close popup
  document.addEventListener("click", (e) => {
    if (!popupWrap.contains(e.target) && !btn.contains(e.target)) {
      popupWrap.classList.remove("active");
      iconMenu.style.display = "block";
      iconClose.style.display = "none";
      btn.setAttribute("aria-expanded", "false");
    }
  });
});

// ============== Form And Destil fix and useLayoutEffect(menu) Active Start ========
document.addEventListener("DOMContentLoaded", function () {

    const sections = document.querySelectorAll(
        "#overview, #spaces, #services, #access"
    );

    const menuLinks = document.querySelectorAll(".details_menu a");

    function onScroll() {
        let scrollPos = window.scrollY + 120;

        sections.forEach(section => {
            const top = section.offsetTop;
            const height = section.offsetHeight;
            const id = section.getAttribute("id");

            if (scrollPos >= top && scrollPos < top + height) {
                menuLinks.forEach(link => link.classList.remove("active"));
                document
                    .querySelector('.details_menu a[href="#' + id + '"]')
                    .classList.add("active");
            }
        });
    }

    window.addEventListener("scroll", onScroll);
}); 
// ============== Form And Destil fix and useLayoutEffect(menu) Active End ======== 

// Hero Popup End

document.addEventListener("DOMContentLoaded", () => {
    // Support multiple gallery tracks (for Content Gallery and Product Gallery sections)
    const tracks = document.querySelectorAll('.about_gallery_track');
    
    tracks.forEach(track => {
    if (!track) return;
    
    const items = [...track.children];
        if (items.length === 0) return;

    // Clone items for seamless infinite scroll
    items.forEach(item => {
        const clone = item.cloneNode(true);
        track.appendChild(clone);
    });

    // total width of original items
    const originalWidth = items.reduce((sum, item) => sum + item.offsetWidth, 0);
        if (originalWidth === 0) return;

    // Get speed from CSS variable or use default
    const scrollSpeedSetting = parseFloat(getComputedStyle(track).getPropertyValue('--gallery-scroll-speed')) || 40;
    
    // Calculate speed in pixels per frame (60fps)
    // Formula: originalWidth / (scrollSpeed in seconds * 60 frames per second)
    let baseSpeed = originalWidth / (scrollSpeedSetting * 60);
    let speed = baseSpeed;       // normal speed
    let slowSpeed = baseSpeed * 0.625;   // hover speed (62.5% of normal)
    let currentSpeed = speed;
    let targetSpeed = speed;

    let position = 0;

    function animate() {
        // smooth speed transition
        currentSpeed += (targetSpeed - currentSpeed) * 0.05;

        // move left-to-right
        position += currentSpeed;

        // modulo reset for infinite smooth scroll
        position = position % originalWidth;

        track.style.transform = `translateX(-${position}px)`;

        requestAnimationFrame(animate);
    }

    animate();

    // hover slow effect
    track.addEventListener("mouseenter", () => targetSpeed = slowSpeed);
    track.addEventListener("mouseleave", () => targetSpeed = speed);
    });
});


// ===== Count Up on Scroll =====
document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll("#statisticsSection h5");
    const section = document.getElementById("statisticsSection");
    const duration = 600; // fast animation (was 3000ms), no need to count one by one

    function animateCounters(timestamp) {
        if (!animateCounters.startTime) animateCounters.startTime = timestamp;
        const elapsed = timestamp - animateCounters.startTime;
        // Ease-out: quick start, smooth finish
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 2);

        counters.forEach(counter => {
            const target = +counter.getAttribute("data-target");
            const display = counter.getAttribute("data-display");
            const current = Math.floor(eased * target);
            counter.innerText = display && progress >= 1 ? display : (target >= 1000 ? current.toLocaleString() : current);
        });

        if (progress < 1) {
            requestAnimationFrame(animateCounters);
        } else {
            counters.forEach(counter => {
                const display = counter.getAttribute("data-display");
                counter.innerText = display || counter.getAttribute("data-target");
            });
        }
    }

    // Intersection Observer to trigger when section center is visible
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                requestAnimationFrame(animateCounters);
                observer.disconnect(); // trigger only once
            }
        });
    }, {
        root: null,             // viewport
        threshold: 0.5          // 50% of section visible (roughly center)
    });

    if (section) {
      observer.observe(section);
    }
});

// ==== Logo Slider 
document.addEventListener("DOMContentLoaded", () => {
    // Support both ID formats: logoSlider and logoSlider-{section.id}
    const slider = document.getElementById("logoSlider") || document.querySelector('[id^="logoSlider"]');
    if (!slider) return;

    // Duplicate all logos once → Seamless infinite loop
    slider.innerHTML += slider.innerHTML;
});


// ==== Animation Effect 
document.addEventListener("DOMContentLoaded", () => {

  // ----------------------
  // SCROLL ANIMATION + TYPE EFFECT
  // ----------------------
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        const el = entry.target;

        // ---------- TYPING EFFECT ----------
        // ---------- TYPING EFFECT ----------
if (el.dataset.type === "true") {
  // Skip if element already has span children (already processed by Liquid template)
  if (el.querySelector('span')) {
    el.classList.add("show");
    return;
  }

  const text = el.textContent.trim();
  el.textContent = "";
  el.classList.add("show");

  const speed = parseFloat(el.dataset.speed) || 0.05;

  // split text by words
  const words = text.split(" ");

  let letterIndex = 0;

  words.forEach((word, wIndex) => {

    // word wrapper (prevents word break)
    const wordSpan = document.createElement("span");
    wordSpan.className = "word";

    // split word into letters
    word.split("").forEach(char => {
      const span = document.createElement("span");
      span.textContent = char;
      span.style.animationDelay = `${letterIndex * speed}s`;
      wordSpan.appendChild(span);
      letterIndex++;
    });

    el.appendChild(wordSpan);

    // add space after word (except last)
    if (wIndex !== words.length - 1) {
      const space = document.createTextNode("\u00A0");
      el.appendChild(space);
      letterIndex++;
    }
  });
}

        // ---------- NORMAL SCROLL ANIMATION ----------
        else {

          const delay = el.dataset.delay || "0s";
          const duration = el.dataset.duration || "0.8s";

          el.style.transitionDelay = delay;
          el.style.transitionDuration = duration;

          el.classList.add("show");
        }

      }
    });
  }, { threshold: 0.4 });

  // ----------------------
  // OBSERVE ELEMENTS
  // ----------------------
  const elements = document.querySelectorAll(
    ".animate, .animate-text, .bottom_to_top, .zoom_bounce, .left_to_right, .right_to_left"
  );

  elements.forEach(el => observer.observe(el));

});



// ===== lazy Image 
document.addEventListener("DOMContentLoaded", function() {
    const lazyImages = document.querySelectorAll('img.lazy');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.add('loaded');
            observer.unobserve(img);
          }
        });
      }, { rootMargin: "0px 0px 100px 0px" });

      lazyImages.forEach(img => {
        if (img && img.nodeType === 1) { // Check if it's an Element
          observer.observe(img);
        }
      });
    } else {
      // fallback for old browsers
      lazyImages.forEach(img => {
        img.src = img.dataset.src;
        img.classList.add('loaded');
      });
    }
  });

// Accordion Image Change
document.addEventListener("DOMContentLoaded", function() {
  const imgBox = document.getElementById("dynamicImage");
  const accordionButtons = document.querySelectorAll("#serviceAccordion .accordion-button");
  const preloadedImages = new Map(); // Cache for preloaded images

  if (imgBox && accordionButtons.length > 0) {
    // Function to preload a single image on demand
    function preloadImage(imgUrl) {
      if (!imgUrl || preloadedImages.has(imgUrl)) {
        return Promise.resolve();
      }
      
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          preloadedImages.set(imgUrl, true);
          resolve();
        };
        img.onerror = reject;
        img.src = imgUrl;
      });
    }

    // Function to update image
    async function updateImage(imgUrl) {
      if (imgUrl && imgBox && imgBox.src !== imgUrl) {
        // Preload the image first (if not already loaded)
        await preloadImage(imgUrl);
        
        // Fade out
        imgBox.classList.add("fade-out");
        // Use requestAnimationFrame for smooth transition
        requestAnimationFrame(() => {
          // Update image
          imgBox.src = imgUrl;
          imgBox.removeAttribute("srcset");
          imgBox.removeAttribute("sizes");
          // Fade in on next frame
          requestAnimationFrame(() => {
            imgBox.classList.remove("fade-out");
          });
        });
      }
    }

    // Set initial image for the first open accordion
    const firstOpen = document.querySelector("#serviceAccordion .accordion-collapse.show");
    if (firstOpen) {
      const initialImg = firstOpen.getAttribute("data-img");
      if (initialImg) {
        updateImage(initialImg);
      }
    }

    // Listen for button clicks and hover (for preloading)
    accordionButtons.forEach(button => {
      // Preload on hover for instant switching
      button.addEventListener("mouseenter", function() {
        const targetId = this.getAttribute("data-bs-target");
        if (targetId) {
          const targetCollapse = document.querySelector(targetId);
          if (targetCollapse) {
            const imgUrl = targetCollapse.getAttribute("data-img");
            if (imgUrl) {
              preloadImage(imgUrl);
            }
          }
        }
      });

      // Update image on click
      button.addEventListener("click", function() {
        const targetId = this.getAttribute("data-bs-target");
        if (targetId) {
          const targetCollapse = document.querySelector(targetId);
          if (targetCollapse) {
            const newImg = targetCollapse.getAttribute("data-img");
            if (newImg) {
              updateImage(newImg);
            }
          }
        }
      });
    });

    // Listen for Bootstrap collapse events (dispatched by navbar-collapse.js)
    const accordions = document.querySelectorAll(".accordion-collapse");
    accordions.forEach(item => {
      // Listen for custom show.bs.collapse event
      item.addEventListener("show.bs.collapse", function () {
        const newImg = this.getAttribute("data-img");
        if (newImg) {
          updateImage(newImg);
        }
      });
    });
  }
});

// Back to Top Button
document.addEventListener("DOMContentLoaded", function() {
  const backToTopBtn = document.querySelector('.back_to_top');
  if (backToTopBtn) {
    backToTopBtn.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '50px'
  });

  const introductionImg = document.querySelector("#introduction_img");
  if (introductionImg) {
    observer.observe(introductionImg);
  }

});

// ======== Shop page Product Filter 
const tabs = document.querySelectorAll(".filter-tabs .nav-link");
  const items = document.querySelectorAll(".product-item");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {

      // active class
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      const filter = tab.getAttribute("data-filter");

      items.forEach(item => {
        if (filter === "all" || item.dataset.category === filter) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });

    });
  });

  // ========== Single Product apge 
  // Img slide 
  const mainImg = document.querySelector('.single_product_view img');
const thumbnails = document.querySelectorAll('.single_product_img_slide img');

thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
        const newSrc = thumb.getAttribute('data-src');

        // fade out main image
        mainImg.classList.add('fade-out');

        // wait for fade out, then change src and fade in
        setTimeout(() => {
            mainImg.setAttribute('data-src', newSrc);
            mainImg.src = newSrc;
            mainImg.classList.remove('fade-out');
        }, 300);

        // remove active class from all thumbnails
        thumbnails.forEach(t => t.classList.remove('active'));

        // add active class to clicked thumbnail
        thumb.classList.add('active');
    });
});


// ===== Single Product Form 
document.addEventListener("click", function (e) {

    // INCREASE
    const increaseBtn = e.target.closest("#increase_qty");
    if (increaseBtn) {
        const box = increaseBtn.closest(".count_number_for_product");
        const qtySpan = box.querySelector("#quantity_value");
        const qtyInput = box.querySelector("#product_quantity");

        let qty = parseInt(qtySpan.textContent);
        qty++;

        qtySpan.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
    }

    // DECREASE
    const decreaseBtn = e.target.closest("#decrease_qty");
    if (decreaseBtn) {
        const box = decreaseBtn.closest(".count_number_for_product");
        const qtySpan = box.querySelector("#quantity_value");
        const qtyInput = box.querySelector("#product_quantity");

        let qty = parseInt(qtySpan.textContent);
        if (qty > 1) qty--;

        qtySpan.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
    }

});



// ============ Single Product Description 
document.addEventListener("DOMContentLoaded", function() {
    const items = document.querySelectorAll(".jholok_custom_accordion .jholok_accordion_item");

    items.forEach(item => {
        const header = item.querySelector(".jholok_accordion_header");

        header.addEventListener("click", () => {
            // Close any other open item
            items.forEach(i => {
                if (i !== item) {
                    i.classList.remove("open");
                }
            });

            // Toggle clicked item
            item.classList.toggle("open");
        });
    });
});

// ======== about page mision vision silder 

document.querySelectorAll('.single_product_view').forEach(box => {
            const img = box.querySelector('img');

            box.addEventListener('mousemove', (e) => {
                const rect = box.getBoundingClientRect();

                const x = ((e.clientX - rect.left) / rect.width) * 100;
                const y = ((e.clientY - rect.top) / rect.height) * 100;

                img.style.transformOrigin = `${x}% ${y}%`;
                img.style.transform = 'scale(1.8)';
            });

            box.addEventListener('mouseleave', () => {
                img.style.transformOrigin = 'center center';
                img.style.transform = 'scale(1)';
            });
        });

// ======== Modal System Start =======
document.addEventListener("DOMContentLoaded", () => {
  // Helper function to open modal - just prevent scrolling, no position manipulation
  const openModal = (modal) => {
    if (!modal || modal.classList.contains('active')) return;
    
    // Show modal - CSS overflow: hidden will prevent scrolling
    modal.classList.add('active');
    document.body.classList.add('modal-open');
    document.documentElement.classList.add('modal-open');
  };
  
  // Helper function to close modal - just remove classes, no scroll manipulation
  const closeModal = (modal) => {
    if (!modal || !modal.classList.contains('active')) return;
    
    // Hide modal - scroll position stays naturally where it is
    modal.classList.remove('active');
    document.body.classList.remove('modal-open');
    document.documentElement.classList.remove('modal-open');
  };
  
  // Generic modal handler for all modals (capture phase so first click opens modal)
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal-trigger]');
    if (trigger) {
      // Capture scroll position before anything else so href="#" cannot reset it
      const savedScrollX = window.scrollX;
      const savedScrollY = window.scrollY;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      // Restore immediately in case the browser already queued a scroll
      window.scrollTo(savedScrollX, savedScrollY);
      const modalId = trigger.getAttribute('data-modal-trigger');
      const modal = document.getElementById(modalId);
      if (modal) {
        openModal(modal);
        // Apply trigger image for private booking modal (capture phase runs first, so do it here)
        if (modalId === 'kraft-private-booking-modal') {
          const triggerImage = trigger.getAttribute('data-modal-image');
          const leftArea = document.getElementById('private-booking-modal-left-area');
          if (triggerImage && leftArea) {
            const img = leftArea.querySelector('img');
            if (img) {
              img.removeAttribute('srcset');
              img.src = triggerImage;
            }
            const leftText = document.getElementById('private-booking-modal-left-text');
            if (leftText) {
              const triggerText = trigger.getAttribute('data-modal-image-text');
              leftText.textContent = triggerText || '';
              leftText.style.display = triggerText ? '' : 'none';
            }
          }
        }
      } else {
        console.error('Modal not found with ID:', modalId);
      }
      return;
    }
    
    // Also handle workshop modal trigger class
    const workshopTrigger = e.target.closest('.workshop-modal-trigger');
    if (workshopTrigger) {
      const savedScrollX = window.scrollX;
      const savedScrollY = window.scrollY;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.scrollTo(savedScrollX, savedScrollY);
      const modal = document.getElementById('kraft-workshop-finder-modal');
      if (modal) {
        openModal(modal);
      }
    }
  }, true);

  // Close modal handlers
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const modalId = closeBtn.getAttribute('data-modal-close');
      const modal = document.getElementById(modalId);
      if (modal) {
        closeModal(modal);
      }
    }
  });

  // Close on overlay click
  document.querySelectorAll('.kraft-modal').forEach(modal => {
    modal.addEventListener('click', (e) => {
      // Check for variant modal container
      const variantContainer = modal.querySelector('.variant-modal-container');
      const modalBox = modal.querySelector('.kraft-modal-box');
      
      // For variant modals, check variant-modal-container
      if (variantContainer) {
        if (!variantContainer.contains(e.target)) {
          closeModal(modal);
        }
      } 
      // For regular modals, check kraft-modal-box
      else if (modalBox && !modalBox.contains(e.target)) {
        closeModal(modal);
      }
    });
  });
});

// ======== Workshop Finder Modal Start =======
document.addEventListener("DOMContentLoaded", () => {
  const workshopModal = document.getElementById('kraft-workshop-finder-modal');
  if (!workshopModal) return;

  const locationOptions = workshopModal.querySelectorAll('[data-location]');

  // Handle location selection
  locationOptions.forEach(option => {
    option.addEventListener('click', () => {
      const selectedLocation = option.getAttribute('data-location');
      const locationLink = option.getAttribute('data-location-link');
      
      // If location has a link, navigate to it
      if (locationLink) {
        // Store location name in sessionStorage for header detection
        if (selectedLocation) {
          sessionStorage.setItem('selectedLocation', selectedLocation);
        }
        window.location.href = locationLink;
      } else {
        // Otherwise, just close the modal
        workshopModal.classList.remove('active');
        document.body.classList.remove('modal-open');
        document.documentElement.classList.remove('modal-open');
      }
    });
  });

  // Handle "Prove It" toggle for reviews
  const proveLinks = workshopModal.querySelectorAll('[data-toggle-reviews]');
  const imageContent = workshopModal.querySelector('[data-content-type="image"]');
  const reviewsContent = workshopModal.querySelector('[data-content-type="reviews"]');
  
  proveLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      
      if (imageContent && reviewsContent) {
        // Toggle visibility
        if (imageContent.style.display === 'none') {
          // Show image, hide reviews
          imageContent.style.display = '';
          reviewsContent.style.display = 'none';
        } else {
          // Hide image, show reviews
          imageContent.style.display = 'none';
          reviewsContent.style.display = '';
        }
      }
    });
  });
});
// ======== Workshop Finder Modal End =======

// ======== Modal image from trigger (no JS prefill; location/workshop from Liquid) =======
document.addEventListener("DOMContentLoaded", () => {
  // Global Modal - apply trigger image only
  const globalModal = document.getElementById('kraft-global-modal');
  if (globalModal) {
    let lastTrigger = null;
    const _globalLeftArea = document.getElementById('global-modal-left-area');
    const _globalLeftText = document.getElementById('global-modal-left-text');
    let _globalDefaultImgSrc = '';
    let _globalDefaultText = '';
    if (_globalLeftArea) {
      var _gImg = _globalLeftArea.querySelector('img');
      if (_gImg) _globalDefaultImgSrc = _gImg.src;
      if (_globalLeftText) _globalDefaultText = _globalLeftText.textContent || '';
    }

    function _applyGlobalModalImage(trigger) {
      var triggerImage = trigger ? trigger.getAttribute('data-modal-image') : null;
      if (triggerImage && _globalLeftArea) {
        var img = _globalLeftArea.querySelector('img');
        if (img) { img.removeAttribute('srcset'); img.src = triggerImage; }
        if (_globalLeftText) {
          var triggerText = trigger.getAttribute('data-modal-image-text');
          _globalLeftText.textContent = triggerText || '';
          _globalLeftText.style.display = triggerText ? '' : 'none';
        }
        return true;
      }
      return false;
    }

    function _resetGlobalModalImage() {
      if (!_globalLeftArea || !_globalDefaultImgSrc) return;
      var img = _globalLeftArea.querySelector('img');
      if (img) { img.removeAttribute('srcset'); img.src = _globalDefaultImgSrc; }
      if (_globalLeftText) {
        _globalLeftText.textContent = _globalDefaultText;
        _globalLeftText.style.display = _globalDefaultText ? '' : 'none';
      }
    }

    function _mapPrefillToDropdownValue(val) {
      if (!val || typeof val !== 'string') return '';
      var t = val.trim();
      var map = { 'Financial District': 'New York', 'Midtown': 'New York', 'Bay Area': 'San Francisco', 'Irvine, CA': 'Irvine', 'Hawaii': 'Honolulu, Hawaii' };
      return map[t] || t;
    }

    function _applyLocationPrefillAndLock(trigger) {
      var prefill = (trigger.getAttribute('data-prefill-location') || '').trim();
      if (!prefill) return;
      var locationValue = _mapPrefillToDropdownValue(prefill);
      var lock = trigger.getAttribute('data-lock-location') === 'true' || trigger.getAttribute('data-lock-fields') === 'true';
      var selects = globalModal.querySelectorAll('#kraft-modal-location-select, #kraft-modal-location-select-alt');
      var locationLower = locationValue.toLowerCase();
      selects.forEach(function(sel) {
        if (!sel || !sel.options) return;
        var options = Array.from(sel.options);
        var opt = options.find(function(o) { return o.value && o.value.toLowerCase().trim() === locationLower; }) ||
                  options.find(function(o) { return o.value && (o.value.toLowerCase().indexOf(locationLower) !== -1 || locationLower.indexOf(o.value.toLowerCase()) !== -1); });
        if (opt && opt.value) {
          sel.value = opt.value;
          if (lock) {
            sel.disabled = true;
            sel.style.backgroundColor = '#f5f5f5';
            sel.style.cursor = 'not-allowed';
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = sel.name;
            hidden.value = sel.value;
            hidden.setAttribute('data-locked-location-field', 'true');
            sel.parentNode.appendChild(hidden);
          }
        }
      });
    }

    function _clearLocationLock() {
      globalModal.querySelectorAll('#kraft-modal-location-select, #kraft-modal-location-select-alt').forEach(function(sel) {
        sel.disabled = false;
        sel.style.backgroundColor = '';
        sel.style.cursor = '';
      });
      globalModal.querySelectorAll('input[data-locked-location-field="true"]').forEach(function(el) { el.remove(); });
    }

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-modal-trigger="kraft-global-modal"]');
      if (trigger) lastTrigger = trigger;
    }, true);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (globalModal.classList.contains('active') && lastTrigger) {
            _applyGlobalModalImage(lastTrigger);
            _applyLocationPrefillAndLock(lastTrigger);
            lastTrigger = null;
          }
        }
      });
    });
    observer.observe(globalModal, { attributes: true, attributeFilter: ['class'] });

    globalModal.querySelectorAll('[data-modal-close]').forEach(btn => {
      btn.addEventListener('click', () => {
        _clearLocationLock();
        _resetGlobalModalImage();
      });
    });
  }

  // Private Booking Modal - apply trigger image or context-aware image only
  const privateModal = document.getElementById('kraft-private-booking-modal');
  if (privateModal) {
    let lastTrigger = null;

    // --- Context-aware image helpers ---
    // Keys: terrarium | mosaic | tufting | moss | birthday | team_building | default
    let _privateImageMap = null;
    const _privateLeftArea = document.getElementById('private-booking-modal-left-area');
    const _privateLeftText = document.getElementById('private-booking-modal-left-text');

    function _loadPrivateImageMap() {
      if (_privateImageMap) return _privateImageMap;
      const el = document.getElementById('private-booking-modal-image-map');
      if (el) {
        try { _privateImageMap = JSON.parse(el.textContent); } catch (e) {}
      }
      return _privateImageMap;
    }

    function _normalizeWorkshopKey(workshop) {
      if (!workshop) return 'default';
      const w = workshop.toLowerCase();
      if (w.includes('terrarium')) return 'terrarium';
      if (w.includes('mosaic') || w.includes('turkish')) return 'mosaic';
      if (w.includes('tufting')) return 'tufting';
      if (w.includes('moss')) return 'moss';
      if (w.includes('birthday') || w.includes('keiki')) return 'birthday';
      if (w.includes('team') && w.includes('build')) return 'team_building';
      return 'default';
    }

    function _applyPrivateBookingImage(workshop) {
      const map = _loadPrivateImageMap();
      if (!map || !_privateLeftArea) return;
      const key = _normalizeWorkshopKey(workshop);
      const entry = (map[key] && map[key].url) ? map[key] : map['default'];
      if (!entry || !entry.url) return;
      const img = _privateLeftArea.querySelector('img');
      if (img) { img.removeAttribute('srcset'); img.src = entry.url; }
      if (_privateLeftText) {
        _privateLeftText.textContent = entry.text || '';
        _privateLeftText.style.display = entry.text ? '' : 'none';
      }
    }

    function _resetPrivateBookingImage() {
      const map = _loadPrivateImageMap();
      if (!map || !_privateLeftArea) return;
      const entry = map['default'];
      if (!entry || !entry.url) return;
      const img = _privateLeftArea.querySelector('img');
      if (img) { img.removeAttribute('srcset'); img.src = entry.url; }
      if (_privateLeftText) {
        _privateLeftText.textContent = entry.text || '';
        _privateLeftText.style.display = entry.text ? '' : 'none';
      }
    }
    // --- End context-aware image helpers ---

    function _applyTriggerImage(trigger) {
      var triggerImage = trigger ? trigger.getAttribute('data-modal-image') : null;
      if (triggerImage && _privateLeftArea) {
        var img = _privateLeftArea.querySelector('img');
        if (img) { img.removeAttribute('srcset'); img.src = triggerImage; }
        if (_privateLeftText) {
          var triggerText = trigger.getAttribute('data-modal-image-text');
          _privateLeftText.textContent = triggerText || '';
          _privateLeftText.style.display = triggerText ? '' : 'none';
        }
        return true;
      }
      return false;
    }

    function _mapPrefillToDropdownValuePrivate(val) {
      if (!val || typeof val !== 'string') return '';
      var t = val.trim();
      var map = { 'Financial District': 'New York', 'Midtown': 'New York', 'Bay Area': 'San Francisco', 'Irvine, CA': 'Irvine', 'Hawaii': 'Honolulu, Hawaii' };
      return map[t] || t;
    }

    function _applyPrivateModalLocationPrefillAndLock(trigger) {
      var prefill = (trigger ? trigger.getAttribute('data-prefill-location') : '') || '';
      prefill = (prefill || '').trim();
      if (!prefill) {
        var pageCtx = document.getElementById('kraft-page-location-context');
        if (pageCtx) prefill = (pageCtx.getAttribute('data-location') || '').trim();
      }
      if (!prefill) return;
      var locationValue = _mapPrefillToDropdownValuePrivate(prefill);
      var lock = (trigger && (trigger.getAttribute('data-lock-location') === 'true' || trigger.getAttribute('data-lock-fields') === 'true')) || !!document.getElementById('kraft-page-location-context');
      var run = function() {
        var selects = privateModal.querySelectorAll('#kraft-private-modal-location-select, #kraft-private-modal-location-select-alt');
        var locationLower = locationValue.toLowerCase();
        selects.forEach(function(sel) {
          if (!sel || !sel.options) return;
          var options = Array.from(sel.options);
          var opt = options.find(function(o) { return o.value && o.value.toLowerCase().trim() === locationLower; }) ||
                    options.find(function(o) { return o.value && (o.value.toLowerCase().indexOf(locationLower) !== -1 || locationLower.indexOf(o.value.toLowerCase()) !== -1); });
          if (opt && opt.value) {
            sel.value = opt.value;
            if (lock) {
              sel.disabled = true;
              sel.style.backgroundColor = '#f5f5f5';
              sel.style.cursor = 'not-allowed';
              var hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = sel.name;
              hidden.value = sel.value;
              hidden.setAttribute('data-locked-location-field', 'true');
              sel.parentNode.appendChild(hidden);
            }
          }
        });
      };
      if (typeof requestAnimationFrame !== 'undefined') {
        requestAnimationFrame(function() { run(); });
      } else {
        setTimeout(run, 50);
      }
    }

    function _clearPrivateModalLocationLock() {
      privateModal.querySelectorAll('#kraft-private-modal-location-select, #kraft-private-modal-location-select-alt').forEach(function(sel) {
        sel.disabled = false;
        sel.style.backgroundColor = '';
        sel.style.cursor = '';
      });
      privateModal.querySelectorAll('input[data-locked-location-field="true"]').forEach(function(el) { el.remove(); });
    }

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-modal-trigger="kraft-private-booking-modal"]');
      if (trigger) lastTrigger = trigger;
    }, true);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (privateModal.classList.contains('active')) {
            if (lastTrigger) {
              if (!_applyTriggerImage(lastTrigger)) {
                _applyPrivateBookingImage(lastTrigger.getAttribute('data-prefill-workshop') || '');
              }
            }
            _applyPrivateModalLocationPrefillAndLock(lastTrigger);
            lastTrigger = null;
          }
        }
      });
    });
    observer.observe(privateModal, { attributes: true, attributeFilter: ['class'] });

    privateModal.querySelectorAll('[data-modal-close]').forEach(btn => {
      btn.addEventListener('click', () => {
        _clearPrivateModalLocationLock();
        _resetPrivateBookingImage();
      });
    });
  }

});
// ======== Modal image-from-trigger End =======
// ======== Modal System End =======
// ======== Cart Drawer Trigger =======
document.addEventListener("DOMContentLoaded", () => {
  // Handle all cart icon clicks (mobile + nav) to open cart drawer
  const cartTriggers = document.querySelectorAll('[data-cart-drawer-trigger]');
  cartTriggers.forEach((cartTrigger) => {
    cartTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer) {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.dispatchEvent(new CustomEvent('open'));
        }
      }
    });
  });
});
// ======== Cart Drawer Trigger End =======

// ======== Video Preview Play Button =======
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const playButton = e.target.closest('[data-video-trigger]');
    if (playButton) {
      e.preventDefault();
      
      const videoUrl = playButton.getAttribute('data-video-url');
      const videoType = playButton.getAttribute('data-video-type') || 'youtube';
      const thumbnailWrapper = playButton.closest('.video-preview-thumbnail-wrapper');
      const thumbnail = playButton.closest('.video-preview-thumbnail');
      
      if (!videoUrl || !thumbnail) return;
      
      // Hide play button
      playButton.style.display = 'none';
      
      // Hide thumbnail image
      const thumbnailImg = thumbnail.querySelector('img');
      if (thumbnailImg) {
        thumbnailImg.style.display = 'none';
      }
      
      // Create video iframe
      let iframeSrc = '';
      
      if (videoType === 'youtube') {
        // Extract YouTube video ID
        let videoId = '';
        const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
        const match = videoUrl.match(youtubeRegex);
        if (match) {
          videoId = match[1];
        } else {
          // Try to extract from URL directly
          const urlParams = new URLSearchParams(videoUrl.split('?')[1]);
          videoId = urlParams.get('v') || videoUrl.split('/').pop().split('?')[0];
        }
        iframeSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      } else if (videoType === 'vimeo') {
        // Extract Vimeo video ID
        const vimeoRegex = /(?:vimeo\.com\/)(\d+)/;
        const match = videoUrl.match(vimeoRegex);
        const videoId = match ? match[1] : videoUrl.split('/').pop();
        iframeSrc = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      } else if (videoType === 'direct') {
        // Direct video - create video element instead
        const video = document.createElement('video');
        video.src = videoUrl;
        video.controls = true;
        video.autoplay = true;
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        thumbnail.appendChild(video);
        return;
      }
      
      // Create and insert iframe
      if (iframeSrc) {
        const iframe = document.createElement('iframe');
        iframe.src = iframeSrc;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.border = 'none';
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        iframe.setAttribute('frameborder', '0');
        
        thumbnail.appendChild(iframe);
      }
    }
  });
});
// ======== Video Preview Play Button End =======

// ======== Contact Modal with Location Info ========
document.addEventListener('DOMContentLoaded', () => {
  const contactModal = document.getElementById('kraft-contact-modal');
  if (!contactModal) return;

  // --- Per-section modal image override (capture phase, before modal opens) ---
  const contactLeftArea = document.getElementById('contact-modal-left-area');

  function applyContactImage(imageUrl, imageText) {
    if (!contactLeftArea) return;
    const img = contactLeftArea.querySelector('.kraft-contact-modal-img');
    const textEl = document.getElementById('contact-modal-left-text');
    if (img) {
      img.src = imageUrl || '';
      img.removeAttribute('srcset');
      img.style.display = imageUrl ? '' : 'none';
    }
    if (textEl) {
      textEl.textContent = imageText || '';
      textEl.style.display = imageText ? '' : 'none';
    }
    contactLeftArea.classList.toggle('kraft-modal-left-area--empty', !imageUrl);
  }

  function resetContactImage() {
    const defaultImage = contactModal.getAttribute('data-contact-default-image') || '';
    const defaultText = contactModal.getAttribute('data-contact-default-image-text') || '';
    applyContactImage(defaultImage, defaultText);
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-modal-trigger="kraft-contact-modal"]');
    if (!trigger) return;
    const defaultImage = contactModal.getAttribute('data-contact-default-image') || '';
    const defaultText = contactModal.getAttribute('data-contact-default-image-text') || '';
    const triggerImage = trigger.getAttribute('data-modal-image');
    const triggerText = trigger.getAttribute('data-modal-image-text');
    const imageUrl = triggerImage || defaultImage;
    const imageText = triggerImage ? (triggerText || '') : defaultText;
    applyContactImage(imageUrl, imageText);
  }, true);

  const contactObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class' && !contactModal.classList.contains('active')) {
        resetContactImage();
      }
    });
  });
  contactObserver.observe(contactModal, { attributes: true, attributeFilter: ['class'] });

  // Listen for contact modal trigger clicks
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-modal-trigger="kraft-contact-modal"]');
    if (!trigger) return;

    e.preventDefault();

    // Get contact data from button attributes
    const locationName = trigger.getAttribute('data-location') || 'Get in Touch';
    const address = trigger.getAttribute('data-contact-address') || '';
    const phone = trigger.getAttribute('data-contact-phone') || '650-460-2411';
    const email = trigger.getAttribute('data-contact-email') || 'hello@kraftstories.com';
    const hours = trigger.getAttribute('data-contact-hours') || 'Mon-Fri: 9AM-6PM\nSat-Sun: 10AM-5PM';
    const prefillSubject = trigger.getAttribute('data-prefill-workshop') || trigger.getAttribute('data-prefill-subject') || '';

    // Small delay to ensure modal is opened first
    setTimeout(() => {
      // Prefill subject (e.g. "Maker Kids Studio - Parent Call")
      const subjectInput = contactModal.querySelector('input[name="subject"]');
      if (subjectInput && prefillSubject) {
        subjectInput.value = prefillSubject;
      }

      // Update location name
      const locationNameEl = contactModal.querySelector('.kraft-modal-contact-location-name');
      if (locationNameEl) {
        locationNameEl.textContent = locationName;
      }

      // Update address (show/hide based on presence)
      const addressItem = contactModal.querySelector('[data-contact-type="address"]');
      const addressValue = contactModal.querySelector('[data-contact-address]');
      if (address && address.trim() !== '') {
        if (addressItem) addressItem.style.display = 'flex';
        if (addressValue) addressValue.textContent = address;
      } else {
        if (addressItem) addressItem.style.display = 'none';
      }

      // Update phone
      const phoneValue = contactModal.querySelector('[data-contact-phone]');
      if (phoneValue) phoneValue.textContent = phone;

      // Update email
      const emailValue = contactModal.querySelector('[data-contact-email]');
      if (emailValue) emailValue.textContent = email;

      // Update hours (convert \n to <br>)
      const hoursValue = contactModal.querySelector('[data-contact-hours]');
      if (hoursValue) {
        hoursValue.innerHTML = hours.replace(/\\n/g, '<br>').replace(/\n/g, '<br>');
      }
    }, 50);
  });
});
// ======== Contact Modal End ========

